import React from 'react';
import styled from 'styled-components';

import BackButton from './BackButton';
import { H1 } from '@ad-scripts/presentation/components/common/headers';
import InlineContainer from '@ad-scripts/presentation/components/common/containers/inline_container';
import InsetContainer from '@ad-scripts/presentation/components/common/containers/inset_container';
import PaginateLight from '@ad-scripts/presentation/components/common/paginate_light';
import Search from 'src/presentation/components/layouts/table/Search';
import StackContainer from '@ad-scripts/presentation/components/common/containers/stack_container';

const TableHeader: React.FC<{
  actionButtons: any;
  backButtonUrl?: string;
  backButtonLabel?: string;
  currentPage?: number;
  dataAid?: string;
  description?: any;
  disableSearch?: boolean;
  header: any;
  items?: any[];
  leftBottomSlot?: JSX.Element;
  onChangeSearchFilter: any;
  pageSize?: number;
  paginationItemsTitle?: string;
  searchInputControl?: JSX.Element;
  searchPlaceholder: string;
  searchString?: string;
  setInputRef?: any;
  setSearchRef?: any;
  showPagination?: boolean;
  updatePage?: Function;
}> = props => {
  const {
    actionButtons,
    backButtonUrl,
    backButtonLabel,
    currentPage,
    dataAid,
    description,
    disableSearch,
    header,
    items,
    leftBottomSlot,
    onChangeSearchFilter,
    pageSize,
    paginationItemsTitle,
    searchInputControl,
    searchPlaceholder,
    searchString,
    showPagination,
    setInputRef,
    setSearchRef,
    updatePage,
  } = props;

  return (
    <TableHeaderContainer>
      <HeaderContainer>
        {backButtonUrl && (
          <BackButton data-aid="header-back-button" label={backButtonLabel || 'Back'} backUrl={backButtonUrl} />
        )}
        <H1 data-aid="header-title">{header}</H1>
        {description && <Description data-aid="header-description">{description}</Description>}
      </HeaderContainer>
      <ActionContainer>
        <SearchAndSlotContainer>
          <Search
            dataAid={dataAid}
            disableSearch={disableSearch}
            onChangeSearchFilter={onChangeSearchFilter}
            searchInputControl={searchInputControl}
            searchPlaceholder={searchPlaceholder}
            searchString={searchString}
            setInputRef={setInputRef}
            setSearchRef={setSearchRef}
          />
          {leftBottomSlot}
        </SearchAndSlotContainer>

        <ButtonsAndPaginationContainer>
          <HeaderButtons>{actionButtons}</HeaderButtons>
          <StyledPaginateLight
            currentPage={currentPage}
            list={items}
            onChange={updatePage}
            pageSize={pageSize}
            showPagination={showPagination}
            title={paginationItemsTitle}
          />
        </ButtonsAndPaginationContainer>
      </ActionContainer>
    </TableHeaderContainer>
  );
};

TableHeader.propTypes = {};

const HeaderContainer = styled(StackContainer).attrs({ inset: 'none', stack: 'large' })`
  padding-bottom: 0;
`;

const ActionContainer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const SearchAndSlotContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
`;

const ButtonsAndPaginationContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
`;

const StyledPaginateLight = styled(PaginateLight)`
  margin-top: 18px;
`;

const HeaderButtons = styled(InlineContainer).attrs({ inset: 'none' })`
  justify-content: flex-start;
`;

const TableHeaderContainer = styled(InsetContainer).attrs({ inset: 'large' })`
  border-top-left-radius: ${p => p.theme.borderRadius.large};
  border-top-right-radius: ${p => p.theme.borderRadius.large};
  padding-bottom: 12px;
`;

const Description = styled(StackContainer).attrs({ stack: 'none', inset: 'none' })`
  color: ${p => p.theme.colors.gray700};
  line-height: 1.6;
`;

export default TableHeader;
